<p>delete-rule works!</p>
